import { ReducerState } from '../../store.types';

export const mastercardSelector = ({ mastercard }: ReducerState) => mastercard;
